<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.margin-tb-5 {
  margin: 5px 0;
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">{{ '共享预约订单' }}</div>
      <div class="page-action-btns flex margin-tb-10">
        <button class="common-bg-button" @click="listDetailFun('check')">查 看</button>
        <!-- <button class="common-bg-button" @click="listDetailFun('edit')">编 辑</button> -->
        <button class="common-bg-button" @click="toHandelRecord()">查看日志</button>
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="reset()">重 置</button>
        <button class="common-bg-button" @click="getListData(pagination, true, isNormal)">
          搜 索
        </button>
        <button class="common-bg-button" @click="() => {
          showMultiQuerys = !showMultiQuerys;
        }">高级筛选</button>
      </div>
      <!-- 高级筛选 -->
      <div class="multi-query-div el-fade-in-linear" v-if="showMultiQuerys">
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="6">
              <p class="margin-tb-5 font-14">下单用户手机号</p>
              <el-input clearable v-model="queryInfo.userPhone" size="small" placeholder="请输入下单用户手机号"></el-input>
            </el-col>
            <!-- <el-col :span="6">
              <p class="margin-tb-5 font-14">订单编号</p>
              <el-input clearable v-model="queryInfo.orderNo" size="small" placeholder="请输入订单编号"></el-input>
            </el-col>
            <el-col :span="6">
              <p class="margin-tb-5 font-14">充电桩IMEI编号</p>
              <el-input clearable v-model="queryInfo.pileCode" size="small" placeholder="请输入充电桩IMEI编号"></el-input>
            </el-col> -->
            <el-col :span="6">
              <p class="margin-tb-5 font-14">订单状态</p>
              <el-select v-model="queryInfo.orderStatus" size="small" filterable class="full-width" clearable
                placeholder="请选择" :disabled='!isNormal'>
                <el-option v-for="item in statusList" :key="item.configVal" :label="item.configName"
                  :value="item.configVal"></el-option>
              </el-select>
            </el-col>
            <!-- <el-col :span="6">
              <p class="margin-tb-5 font-14">结束方式</p>
              <el-select v-model="queryInfo.chargeOverReason" size="small" filterable class="full-width" clearable
                placeholder="请选择">
                <el-option label="拔枪" value="拔枪"></el-option>
                <el-option label="车主动断开" value="车主动断开"></el-option>
                <el-option label="指令" value="指令"></el-option>
                <el-option label="充满" value="充满"></el-option>
                <el-option label="刷卡" value="刷卡"></el-option>
                <el-option label="桩故障" value="桩故障"></el-option>
              </el-select>
            </el-col> -->
            <el-col :span="6">
              <p class="margin-tb-5 font-14">当前预约开始结束时间</p>
              <div class="flex-r">
                <el-date-picker class="full-width" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="chargeTime" @change="pickdate(chargeTime)" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </el-col>
            <!-- <el-col :span="6">
              <p class="margin-tb-5 font-14">充电时间</p>
              <div class="flex-r">
                <el-date-picker class="full-width" size="small" type="daterange" value-format="yyyy-MM-dd"
                  v-model="chargeTime" @change="pickdate(chargeTime)" range-separator="-" start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </div>
            </el-col> -->
            <el-col :span="6" v-if="!isNormal">
              <p class="margin-tb-5 font-14">异常处理状态</p>
              <el-select v-model="queryInfo.processingStatus" size="small" filterable class="full-width" clearable
                placeholder="请选择">
                <el-option label="已处理" value="Y"></el-option>
                <el-option label="未处理" value="N"></el-option>
              </el-select>
            </el-col>
          </el-row>
        </div>
      </div>
      <!-- 表格 -->
      <div class="list-table">
        <ZD-table :tableColumns="listColumns" :operates="operates" :tableData="tableData"
          :tableConfig="pageConfig.tableConfig" :selections="selections"
          v-on:updateSelections="(sels) => { selections = sels }"></ZD-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination :pagination="pagination"
          v-on:pageUpdate="getListData(pagination, false, isNormal)"></ZD-pagination>
      </div>
    </div>
    <!-- 操作日志 -->
    <el-dialog title="操作日志" width="60%" :visible.sync="handelRecordObj.showDialog">
      <el-table class="el-table" :data="handelRecordObj.tableData" border max-height="600px"
        style="width: 100%;margin:20px auto"
        :header-cell-style="{ background: '#FAFAFA', color: '#8F9BB3', fontSize: '14px', textAlign: 'center', border: '1px solid #F0F0F0' }">
        <el-table-column prop="lastModifiedByName" width="80" label="操作人">
        </el-table-column>
        <el-table-column prop="lastModifiedWhen" width="160" label="更改时间">
        </el-table-column>
        <el-table-column prop="data" min-width="300" label="更改数据">
        </el-table-column>
      </el-table>
      <div class="list-pagination">
        <ZD-pagination :pagination="handelRecordObj.pagination" v-on:pageUpdate="toHandelRecord"></ZD-pagination>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from './page-config'
export default {
  data() {
    return {
      pageConfig: pageConfig, // 页面配置
      listColumns: pageConfig.listColumns,
      tableData: [], // 表格数据
      selections: [], // 表格选项
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuerys: false,
      isNormal: true,
      chargeTime: [],
      statusList: [
        {
          configVal: 'SUCCESS',
          configName: '预约成功',
        },
        {
          configVal: 'CANCEL',
          configName: '已取消',
        },
        {
          configVal: 'FINISHED',
          configName: '已完成',
        },
        {
          configVal: 'TIMEOUT',
          configName: '超时关闭',
        },
        {
          configVal: 'FAILED',
          configName: '启动失败',
        },
      ],
      operates: {
        width: 220,
        fixed: 'right',
        list: [],
      }, // 列操作按钮
      handelRecordObj: {
        showDialog: false,
        tableData: [],
        pagination: {
          current: 1,
          total: 0,
          pageSize: 10,
          pageSizes: [10, 20, 50, 100],
        },
      },
    }
  },
  methods: {
    //查找站点名称 获取数据
    init() {
      this.getListData(this.pagination, true, this.isNormal)
    },
    // 获取表格数据
    getListData(pagination, reload = false, isNormal = true) {
      let _ = this
      _.$U.showLoading(_)
      _.queryInfo.pageNum = pagination.current - 1
      if (reload) {
        _.pagination.current = 1
        _.queryInfo.pageNum = 0
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.digitization.sharePileOrderList, _.queryInfo).then(res => {
        _.tableData = res.data.data.content || []
        _.pagination.total = res.data.data.totalElements || 0
        _.$U.hideLoading(_)
      })
    },
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error('请选择需要操作的对象');
        return false;
      }
      if (selections.length > 1) {
        this.$U.error('只能选择一个操作的对象');
        return false;
      }
      return true;
    },
    //页面编辑方法
    listDetailFun(status) {
      let _ = this
      if (_.checkSelectOne(_.selections)) {
        let routeUrl = this.$router.resolve({
          name: 'sharedBookingDetail',
          query: {
            reserveOrderNo: _.selections[0].reserveOrderNo
          }
        });
        window.open(routeUrl.href, '_blank');
      }
    },
    pickdate(time) {
      let _ = this;
      // 拆分时间区间
      _.queryInfo.reserveOrderStartTime = time ? time[0] : ''
      _.queryInfo.reserveOrderEndTime = time ? time[1] : ''
    },
    toHandelRecord() {
      let _ = this;
      let obj = {
        pageNum: _.handelRecordObj.pagination.current - 1,
        pageSize: _.handelRecordObj.pagination.pageSize,
        webType: 'pileOrder'
      }
      _.$H.post(_, _.$A.digitization.webLog, obj).then(res => {
        _.handelRecordObj.tableData = res.data.data.content || [];
        _.handelRecordObj.pagination.total = res.data.data.totalElements || 0;
        _.handelRecordObj.showDialog = true;
      })
    },
    //重置
    reset() {
      this.queryInfo = {}
      this.chargeTime = []
      this.pagination.current = 1
      this.$nextTick(() => {
        this.getListData(this.pagination, true, this.isNormal)
      })
    },
  },
  mounted() {
    this.init()
  },
  watch: {

  }
}
</script>
